/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Brazilian Portuguese (pt) · Journal / blog page
   English is the source of truth in blog.html; this file supplies the
   Portuguese counterpart for each blog.* data-i18n key. Missing keys
   fall back to English automatically (see i18n.js).

   Brazilian Portuguese (pt-BR), not European. Use "você", gerund tenses,
   BR vocabulary (hidratante, tela, geladeira). No em dashes (use periods,
   commas, or the mid-dot · ). Standalone "serum" → "sérum".
═════════════════════════════════════════════════════════════════════ */
(function(){
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.pt = window.TD_I18N.pt || {};
  Object.assign(window.TD_I18N.pt, {

    /* ── Footer · extra link not on the homepage ── */
    'footer.learn.about': 'Sobre o Dr. Ronlán',

    /* ── Page head ── */
    'blog.eyebrow': 'Journal',
    'blog.title': 'Notas do<br><em>laboratório.</em>',
    'blog.intro': 'A ciência, os sérums e os rituais de cuidado na Transderma: trinta anos de pesquisa, traduzidos para a prateleira do banheiro.',

    /* ── Filter bar ── */
    'blog.filter.all': 'Todos',
    'blog.filter.science': 'Ciência',
    'blog.filter.ingredients': 'Ingredientes',
    'blog.filter.routines': 'Rotinas',
    'blog.filter.longevity': 'Longevidade',

    /* ── Shared "Read" link ── */
    'blog.read': 'Ler <span class="arr">→</span>',

    /* ── Coming-soon labels (theme template; articles not yet live) ── */
    'blog.soon': 'Em breve',
    'blog.notice.upcoming': 'Os artigos serão publicados em breve · cadastre-se abaixo para ser avisado',

    /* ── Article 1 (featured) ── */
    'blog.a1.cat': 'Ciência',
    'blog.a1.time': '7 min de leitura',
    'blog.a1.date': 'Abr 2026',
    'blog.a1.title': 'Por que skincare <em>sem água</em> realmente funciona, e por que a maioria dos sérums não.',
    'blog.a1.excerpt': 'Entre sessenta e noventa por cento do conteúdo de um frasco médio de sérum é água. O resto: emulsificantes, espessantes e conservantes. Quando dizemos que a Transderma é sem água, queremos dizer que cada gota é fórmula ativa. Aqui está a química por trás dessa escolha, e por que ela muda o que realmente chega à pele.',
    'blog.a1.read': 'Ler o artigo <span class="arr">→</span>',

    /* ── Article 2 ── */
    'blog.a2.cat': 'Ingredientes',
    'blog.a2.time': '5 min',
    'blog.a2.title': 'Palmitato de retinila versus retinol: um caminho mais suave para a renovação.',
    'blog.a2.excerpt': 'Por que o Serum A usa o éster palmitato da vitamina A: como ele se converte dentro da pele, por que é estabilizado com vitamina E, e para quem é mais indicado.',

    /* ── Article 3 ── */
    'blog.a3.cat': 'Ciência',
    'blog.a3.time': '6 min',
    'blog.a3.title': 'A difusão transdérmica, explicada para a prateleira do banheiro.',
    'blog.a3.excerpt': 'O que "além do stratum corneum" realmente significa, como o esqualano transporta vitaminas ativas através da camada externa da pele, e a pesquisa em profundidade por trás do nome.',

    /* ── Article 4 ── */
    'blog.a4.cat': 'Rotinas',
    'blog.a4.time': '4 min',
    'blog.a4.title': 'Monte uma rotina Transderma em cinco etapas.',
    'blog.a4.excerpt': 'Manhã, noite, ordem de aplicação, e como adicionar o Serum M sem diluir o ativo embaixo. O ritmo que transforma cinco frascos em um sistema.',

    /* ── Article 5 ── */
    'blog.a5.cat': 'Longevidade',
    'blog.a5.time': '8 min',
    'blog.a5.title': 'A questão mitocondrial: por que o Serum O é o sérum da longevidade.',
    'blog.a5.excerpt': 'PQQ, creatina, vitaminas B. O argumento para tratar o envelhecimento cutâneo no nível da energia celular, e por que o suporte mitocondrial está no centro da fórmula mais distintiva da linha.',

    /* ── Article 6 ── */
    'blog.a6.cat': 'Ingredientes',
    'blog.a6.time': '5 min',
    'blog.a6.title': 'Resveratrol, piceído e a ciência por trás das marcas pós-acne.',
    'blog.a6.excerpt': 'Como quatro ingredientes (e nenhuma água) abordam o tom desigual, os danos ambientais e as marcas que persistem muito depois que a espinha desaparece.',

    /* ── Article 7 ── */
    'blog.a7.cat': 'Ciência',
    'blog.a7.time': '6 min',
    'blog.a7.title': 'Ceramidas, colesterol e a argamassa lipídica da pele.',
    'blog.a7.excerpt': 'Por que uma barreira que retém sua própria hidratação é o objetivo, e como o Serum M complementa os lipídios que a sua pele já sabe produzir.',

    /* ── Article 8 ── */
    'blog.a8.cat': 'Rotinas',
    'blog.a8.time': '3 min',
    'blog.a8.title': 'Duas gotas bastam. O argumento contra o uso em excesso.',
    'blog.a8.excerpt': 'Um sérum concentrado sem água não se comporta como um hidratante com 65% de água. Por que menos produto rende mais quando a fórmula trabalha com a sua pele, não contra ela.',

    /* ── Newsletter ── */
    'blog.news.eyebrow': 'The Journal · Mensal',
    'blog.news.title': 'Uma carta breve <em>todo mês.</em>',
    'blog.news.body': 'Novos artigos, novidades discretas de produtos e, de vez em quando, uma palavra do laboratório. Sem promoções, sem enrolação. Uma nota refletida e um link para cancelar inscrição em cada e-mail.',
    'blog.news.placeholder': 'seu@email.com',
    'blog.news.aria': 'Endereço de e-mail',
    'blog.news.button': 'Cadastrar'

  });
})();
